export const USER_TYPES = {
  facilitator: 'Facilitator',
  player: 'Player',
  user: 'User'
}
